import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorLoggingService {
 
  log(message: string): void {
    console.log(message);
  }
 
  logError(message: string): void {    
    console.error(message);
  }
}